import React from "react";
import "./Title.scss";

function Title({ title, icon }) {
  return (
    <div className="Title Flink-container">
      <h3>
        {icon && <img src={icon} alt="" />}
        {title}
      </h3>
    </div>
  );
}

export default Title;
